// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__ri2cL","amount":"Amount_amount__1J614","tip":"Amount_tip__3tu9J","tipHeader":"Amount_tipHeader__1S7Hs","tipsWrap":"Amount_tipsWrap__tsPLB"};